import { render } from "./mch_index.vue?vue&type=template&id=9a589268&scoped=true"
import script from "./mch_index.vue?vue&type=script&lang=js"
export * from "./mch_index.vue?vue&type=script&lang=js"

import "./mch_index.vue?vue&type=style&index=0&id=9a589268&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a589268"]])

export default __exports__